module.exports = __webpack_public_path__ + "static/media/cowbell.cf111d25.svg";